module.exports = __webpack_public_path__ + "img/versapay-overview-4.8e852d67.png";